import { Snackbar, Alert } from '@mui/material';

import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { useLocation } from 'react-router-dom';

import { setToastMessage } from 'common/store/reducer/commonReducer';

import styles from './ToastMessage.module.scss';

const { successColor } = styles;

interface Props {
	open: boolean;
	toastMessage: string;
	severity: any;
	vertical: 'top' | 'bottom';
	horizontal: 'right' | 'left' | 'center';
	autoHideDuration?: number;
	handleCloseMessage: () => void;
	variant?: 'standard' | 'filled' | 'outlined';
	icon?: any;
	color?: any;
	className?: string;
	zIndex?: number;
}
const AlertComponent = (props: Props) => {
	const {
		open,
		vertical,
		horizontal,
		toastMessage,
		severity,
		autoHideDuration = 5000,
		handleCloseMessage,
		variant,
		icon,
		color,
		className,
		zIndex = 1400,
	} = props;
	const location = useLocation();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			setToastMessage({
				isToastOpen: false,
				message: '',
				severity: '',
			}),
		);
	}, [location?.pathname]);

	return (
		<div data-testid="alert-component">
			{' '}
			<Snackbar
				sx={{
					zIndex,
					width: '100%',
					'& .SnackbarItem-variantSuccess': {
						backgroundColor: successColor,
					},
				}}
				open={open}
				autoHideDuration={autoHideDuration}
				onClose={handleCloseMessage}
				key={vertical + horizontal}
				anchorOrigin={{ vertical, horizontal }}
			>
				<Alert
					onClose={handleCloseMessage}
					className={className}
					severity={severity}
					variant={variant}
					icon={icon}
					color={color}
				>
					{open ? toastMessage : null}
				</Alert>
			</Snackbar>
		</div>
	);
};

export default AlertComponent;
